import { carTitle } from './documentTitle';

/**
 * Alternative text for the storefront's photos (BUG-18: every `<img>` said `Image` — an attribute
 * that satisfies a validator and tells a blind buyer nothing about which car it is).
 */

/** A listing-like object (or nothing, while it loads), or the car's name when the screen has it. */
type CarLike = Parameters<typeof carTitle>[0] | string | null | undefined;

const nameOf = (car: CarLike): string => {
  if (!car) {
    return '';
  }

  return typeof car === 'string' ? car.trim() : carTitle(car);
};

/** `BMW X5 2021 — photo 2 of 5`; the position is dropped when there is only one photo. */
export const carPhotoAlt = (car: CarLike, index = 0, total = 1): string => {
  const name = nameOf(car) || 'Car';

  return total > 1 ? `${name} — photo ${index + 1} of ${total}` : name;
};

/** The placeholder shown when a listing has no photos: says so, instead of pretending to be one. */
export const noPhotoAlt = (car: CarLike): string => {
  const name = nameOf(car);

  return name ? `No photo of ${name} yet` : 'No photo yet';
};
